import * as yup from "yup";

export const criarLoteSchema = yup.object({
  tipoLancamento: yup.string().required("Campo obrigatório"),
  fornecedor: yup
    .number()
    .moreThan(0, "O fornecedor é obrigatório")
    .required("O fornecedor é obrigatório"),
  numeroNfRecibo: yup
    .string()
    .required("O número do recibo ou da NF é obrigatório"),
  valorNfRecibo: yup
    .string()
    .typeError("O valor do recibo ou da NF é obrigatório")
    .required("O valor do recibo ou da NF é obrigatório")
    .test("valor", "O valor do recibo ou da NF é obrigatório", (value) => {
      return !["", "0.00"].includes(value);
    }),
  arquivo: yup
    .mixed()
    .required("Selecione um arquivo")
    .test(
      "file-selected",
      "Selecione um arquivo",
      (value) => value instanceof File && value.size > 0
    ),
});
